import type { TemplateFormsState } from '../index';
import { getStartPos } from 'utils/section/gridUtils';
import type { LayoutType } from 'types';

interface ResizePayload {
  sectionName: string;
  layoutType: LayoutType;
  originalPosition: {
    x: string;
    y: string;
  };
  newPosition: {
    x: string;
    y: string;
  };
  subTabId?: string | null;
}

export const resizeSectionItem = (state: TemplateFormsState, { payload }: { payload: ResizePayload }) => {
  const { sectionName, layoutType, originalPosition, newPosition, subTabId } = payload;

  const sections = state[layoutType].sections;

  const sectionIndex = sections.findIndex((section) => section.name === sectionName);
  if (sectionIndex === -1) return;

  const items = sections[sectionIndex].items;
  const targetSubTab = subTabId ?? null;

  const itemIndex = items.findIndex((item) => {
    if (!item.name && !item?.settings?.delimiter) return false;

    const iX = getStartPos(item.x);
    const iY = getStartPos(item.y);
    const sX = getStartPos(originalPosition.x);
    const sY = getStartPos(originalPosition.y);
    const itemSubTab = item.subTabId ?? null;

    return iX === sX && iY === sY && itemSubTab === targetSubTab;
  });

  if (itemIndex !== -1) {
    const item = items[itemIndex];

    item.x = String(newPosition.x);
    item.y = String(newPosition.y);

    items[itemIndex] = item;
  }
};
